import { useMutation, useQueryClient } from '@tanstack/react-query';
import { CLUserApi } from 'api/CL/CLUserApi';
import { UpdateFavoriteUserReqData } from 'models/CL/CLApiTypes';
import { useLoadingStore } from 'store/useLoadingStore';
import { useLoginStore } from 'store/useLoginDataStore';

const useUpdateFavoriteUserMutation = () => {
    const queryClient = useQueryClient();
    const { loginData } = useLoginStore();
    const { setLoading } = useLoadingStore();

    return useMutation({
        mutationFn: async (rqData: UpdateFavoriteUserReqData) => {
            try {
                setLoading(true);

                const response = await CLUserApi.updateFavoriteUser(rqData, process.env.REACT_APP_CL_ADMIN_KEY!);
                if (response.status === 'ok') return response.data;
                throw new Error('API 응답 오류');
            } catch (error) {
                const errorMessage = error instanceof Error ? error.message : '알 수 없는 오류가 발생했습니다';
                throw new Error(errorMessage);
            } finally {
                setLoading(false);
            }
        },
        onSuccess: () => {
            // 즐겨찾기 리스트와 일반 리스트 모두 갱신
            queryClient.invalidateQueries({ queryKey: ['getFavoriteUserListQueries'] });
            queryClient.invalidateQueries({ queryKey: ['getUserListQueries'] });
        },
        retry: 1,
    });
};

export default useUpdateFavoriteUserMutation; 